import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import {Link as RouterLink} from 'react-router'
import Styles from './Link.css'
import analytics from '../../helpers/analytics'

@CSSModules(Styles,{allowMultiple:true})

export default class Link extends Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    targetBlank: PropTypes.bool,
    strong: PropTypes.bool,
    light: PropTypes.bool,
    xstrong: PropTypes.bool,
    primarybutton: PropTypes.bool,
    whitebutton: PropTypes.bool,
    orangebutton: PropTypes.bool,
    aboutmenu: PropTypes.bool,
    aboutmenuactive: PropTypes.bool,
    fundmenu: PropTypes.bool,
    fundmenuactive: PropTypes.bool,
    footer: PropTypes.bool,
    bigbutton: PropTypes.bool,
    donatebanner: PropTypes.bool,
    roundbutton: PropTypes.bool,
    greenbutton: PropTypes.bool,
    log: PropTypes.object,
    title: PropTypes.string
  }
  constructor(props){
    super(props);
  }
  log = () =>{
    if( this.props.log){
      analytics.event(this.props.log)
    }
  }

  render() {
    const title = this.props.title || this.props.to
    let styleName = 'link'
    if(this.props.strong){
      styleName = 'strong'
    }
    if(this.props.light){
      styleName = 'light'
    }
    if(this.props.xstrong){
      styleName = 'xstrong'
    }
    if(this.props.primarybutton){
      styleName = 'primarybutton'
    }
    if(this.props.whitebutton){
      styleName = 'whitebutton'
    }
    if(this.props.orangebutton){
      styleName = 'orangebutton'
    }
    if(this.props.aboutmenu){
      styleName = 'aboutmenu'
    }
    if(this.props.aboutmenuactive){
      styleName = 'aboutmenuactive'
    }
    if(this.props.fundmenu){
      styleName = 'fundmenu'
    }
    if(this.props.fundmenuactive){
      styleName = 'fundmenuactive'
    }
    if(this.props.footer){
      styleName = 'footer'
    }
    if(this.props.bigbutton){
      styleName = 'bigbutton'
    }
    if(this.props.roundbutton){
      styleName = 'roundbutton'
    }
    if(this.props.greenbutton){
      styleName = 'greenbutton'
    }
    if(this.props.donatebanner){
      styleName = 'donatebanner'
    }
    if( this.props.to.match(/^#/) ){
      styleName += ' internal'
      return (
        <a
          styleName={styleName}
          onClick={this.log}
          title={title}
          href={this.props.to}
        >
          {this.props.children}
        </a>
      )
    }
    if (
      this.props.to.match(/^http/) ||
      this.props.to.match(/^mailto/) ||
      this.props.targetBlank
    ){
      return (
        <a
          target='_blank'
          onClick={this.log}
          styleName={styleName}
          title={title}
          href={this.props.to}
        >
          {this.props.children}
        </a>
      )
    }
    return (
      <RouterLink
        styleName={styleName}
        onClick={this.log}
        title={title}
        to={this.props.to}
      >
        {this.props.children}
      </RouterLink>
    )
  }
}
